var _rect, _path, _defs;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBip(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 23,
    viewBox: "0 0 20 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.816406,
    width: 19.3021,
    height: 8.92211,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.11775e-05 18.644H15.3689L19.3299 22.6648V9.76036H0V18.644L1.11775e-05 18.644ZM10.046 2.774C9.8188 2.774 9.63449 2.9583 9.63449 3.18564V5.64066C9.63449 5.64232 9.63496 5.64376 9.63496 5.64541C9.63758 6.57258 10.3923 7.32618 11.3204 7.32618C12.2501 7.32618 13.0065 6.57003 13.0065 5.64066C13.0065 4.71088 12.2501 3.95487 11.3204 3.95487C11.005 3.95487 10.7104 4.04354 10.4578 4.19487V3.18564C10.4578 2.9583 10.2737 2.774 10.046 2.774V2.774H10.046ZM11.3204 4.77815C11.7962 4.77815 12.1828 5.16521 12.1828 5.64067C12.1828 6.11633 11.7962 6.50291 11.3204 6.50291C10.8451 6.50291 10.4578 6.11633 10.4578 5.64067C10.4578 5.16521 10.8451 4.77815 11.3204 4.77815ZM13.8533 3.9579C13.6256 3.9579 13.4415 4.14248 13.4415 4.36961V5.77705C13.4415 6.2762 13.5118 6.97493 14.1182 7.2804C14.3213 7.38244 14.5689 7.30051 14.6712 7.09754C14.7731 6.89417 14.6913 6.64701 14.4882 6.54477C14.433 6.51716 14.2648 6.432 14.2648 5.77705V4.36961C14.2648 4.14248 14.0808 3.9579 13.8533 3.9579L13.8533 3.9579ZM13.8536 2.77565C13.6031 2.77565 13.4005 2.97834 13.4005 3.22867C13.4005 3.47872 13.6031 3.68113 13.8536 3.68113C14.1033 3.68113 14.3064 3.47872 14.3064 3.22867C14.3064 2.97834 14.1033 2.77565 13.8536 2.77565ZM15.9762 7.99256V7.08412C16.2288 7.23551 16.5233 7.32405 16.8386 7.32405C17.7681 7.32405 18.5242 6.56804 18.5242 5.63839C18.5242 4.70895 17.7681 3.95273 16.8386 3.95273C15.9091 3.95273 15.1526 4.70895 15.1526 5.63839V7.99256C15.1526 8.22003 15.3369 8.40406 15.5644 8.40406C15.7919 8.40406 15.9762 8.22003 15.9762 7.99256V7.99256ZM16.8386 4.77608C17.3139 4.77608 17.701 5.16286 17.701 5.63839C17.701 6.11392 17.3139 6.5007 16.8386 6.5007C16.3628 6.5007 15.9762 6.11392 15.9762 5.63839C15.9762 5.16286 16.3628 4.77608 16.8386 4.77608ZM2.90615e-05 0V0.839045H19.33V0H2.90615e-05Z",
    fill: "url(#paint0_linear_14_564)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_14_564",
    x1: 2.70619,
    y1: 11.3324,
    x2: 16.6237,
    y2: 11.3324,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DA251D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501961,
    stopColor: "#89211B"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBip);
export default __webpack_public_path__ + "static/media/bip.cb6616a04dec5c66d570872f044503db.svg";
export { ForwardRef as ReactComponent };